export default {
      id: "icon-localisation-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "icons.svg#icon-localisation",
      toString: function () {
        return this.url;
      }
    }